export default {
  'miner.title': '👥 Miner Management',
  'miner.subtitle': 'List of all users participating in the COW ecosystem',
  'miner.headerTitle': 'Miner List',
  'miner.copySuccess': 'Copied!',
  'miner.walletAddress': 'Wallet Address',
  'miner.userId': 'User ID',
  'miner.socialLinks': 'Social Media',
  'miner.miningStatus': 'Mining Status',
  'miner.createdAt': 'Created At',
  'miner.action': 'Actions',
  'miner.detail': 'Detail',
  'miner.status.ready': 'Ready',
  'miner.status.needSocial': 'Need Social Link',
  'miner.social.x.verified': 'X: Verified',
  'miner.social.x.unverified': 'X: Unverified',
  'miner.social.x.notLinked': 'X: Not Linked',
  'miner.social.telegram.verified': 'Telegram: Verified',
  'miner.social.telegram.unverified': 'Telegram: Unverified',
  'miner.social.telegram.notLinked': 'Telegram: Not Linked',
  'miner.status.restricted': 'Restricted',
  'miner.status.all': 'All',
  'miner.status.title': 'Status',
  'miner.approval.title': 'Approval Requests',
  'miner.approval.subtitle': 'Manage transaction requests from restricted accounts',
  'miner.approval.actionType': 'Action Type',
  'miner.approval.payload': 'Payload',
  'miner.approval.status': 'Status',
  'miner.approval.pending': 'Pending',
  'miner.approval.approved': 'Approved',
  'miner.approval.rejected': 'Rejected',
  'miner.approval.confirmApprove': 'Are you sure you want to approve this request?',
  'miner.approval.confirmReject': 'Are you sure you want to reject this request?',
  'miner.approval.approveSuccess': 'Request approved successfully!',
  'miner.approval.rejectSuccess': 'Request rejected!',
  'miner.approval.approveFailed': 'Approval failed.',
  'miner.approval.modal.title': 'Send Notification to User',
  'miner.approval.modal.msgVi': 'Message (Vietnamese)',
  'miner.approval.modal.msgEn': 'Message (English)',
  'miner.approval.modal.placeholder': 'Enter notification content...',
  'miner.approval.modal.submit': 'Confirm & Send',
  'miner.approval.modal.skip': 'Update Status Only (No Notification)',
  'miner.approval.modal.cancel': 'Cancel',
  'miner.approval.modal.processing': 'Processing:',
  'miner.approval.modal.sendTo': 'Send to wallet:',
  'miner.approval.modal.approveText': 'APPROVE',
  'miner.approval.modal.rejectText': 'REJECT',
  'miner.approval.modal.ruleMsgVi': 'Please enter Vietnamese message',
  'miner.approval.modal.ruleMsgEn': 'Please enter English message',
  'miner.approval.modal.defaultApproveVi': 'Yêu cầu của bạn đã được phê duyệt và tài khoản đã được mở khóa.',
  'miner.approval.modal.defaultRejectVi': 'Rất tiếc, yêu cầu của bạn đã bị từ chối.',
  'miner.approval.modal.defaultApproveEn': 'Your request has been approved and your account is now unlocked.',
  'miner.approval.modal.defaultRejectEn': 'Sorry, your request has been rejected.',
  'miner.approval.approve': 'Approve',
  'miner.approval.reject': 'Reject',
  'miner.approval.action.unlock': 'Unlock Transfer',
};
